import { createContext, useState, useEffect, useContext, useMemo } from 'react';
import { updateMetaObjectCoilSetting } from '../api/adminApi.jsx';
import { StorefrontContext } from './StorefrontContext.jsx';
import * as moment from 'moment';

// Create a context for product coil setting
export const ProductCoilSettingContext = createContext();

export function ProductCoilSettingProvider({ children }) {
    let initialState = [];
    if (localStorage.getItem('coilSettings')) {
        try {
            initialState = JSON.parse(localStorage.getItem('coilSettings'));
        } catch (error) {
            console.error('Error parsing coil settings', error);
        }
    }
    const [productCoilSetting, setProductCoilSetting] = useState(initialState);
    const { state: storefrontStateObject, fetchMetaObject } = useContext(StorefrontContext);

    useMemo(() => {
        if (storefrontStateObject?.coil_setting) {
            const serverCoilSettings = JSON.parse(storefrontStateObject.coil_setting);
            if (serverCoilSettings?.value && serverCoilSettings?.update_at) {
                updateProductCoilSetting(serverCoilSettings?.value, serverCoilSettings?.update_at);
            }
        }
    }, [storefrontStateObject]);

    function updateProductCoilSetting(coilSettings, checkDate = null, skipUpload = false) {
        // parse if the coil settings is a string
        if (typeof coilSettings === 'string') {
            try {
                coilSettings = JSON.parse(coilSettings);
            } catch (error) {
                console.error('Error parsing coil settings', error);
                return;
            }
        }
        let date = new Date();
        if (checkDate) {
            // compare the date;
            const lastUpdate = localStorage.getItem('coilSettingsLastUpdate');
            if (lastUpdate && (new Date(checkDate) < new Date(lastUpdate))) {
                return;
            }
            date = new Date(checkDate);
        }

        const dateString = moment(date).format('yyyy-MM-DD HH:mm:ss');
        console.log('updated coil settings found');
        // update the coil settings in local storage
        localStorage.setItem('coilSettings', JSON.stringify(coilSettings));
        localStorage.setItem('coilSettingsLastUpdate', dateString);

        // upload the coil settings to the server
        if (!skipUpload) {
            updateMetaObjectCoilSetting({
                update_at: dateString,
                value: coilSettings
            });
        }

        // update the coil settings in the context
        setProductCoilSetting(coilSettings);
    }

    function deductProductCountFromCoil(coilId, count = 1) {
        const updatedCoilSettings = productCoilSetting.map((coil) => {
            if (coil.id === coilId) {
                return {
                    ...coil,
                    count: coil.count - count
                }
            }
            return coil;
        });
        updateProductCoilSetting(updatedCoilSettings);
    }

    // function get coils with stocks and not expired
    function getAvailableCoils() {
        return productCoilSetting.filter((coil) => coil.count > 0 && new Date(coil.expiryDate) > new Date());
    }

    return (
        <ProductCoilSettingContext.Provider value={{ productCoilSetting, updateProductCoilSetting, deductProductCountFromCoil, getAvailableCoils, setProductCoilSetting }}>
            {children}
        </ProductCoilSettingContext.Provider>
    );
}